var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('grupo-usuario-list',{attrs:{"carregar":_vm.carregar,"novo":_vm.adicionar,"editar":_vm.editar,"remover":_vm.remover,"colunas":_vm.colunasListagem,"info":_vm.info}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }